export default "__VITE_ASSET__9k_XJfri__"